import { memo, useState } from 'react'

import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark'
import Button from '@space-core/components/button'
import Icon from '@space-core/components/icon'
import Modal from '@space-core/components/modal'
import ModalBody from '@space-core/components/modalBody'
import ModalFooter from '@space-core/components/modalFooter'
import ModalHeader from '@space-core/components/modalHeader'
import useTranslation from '@space-core/hooks/useTranslation'
import useMenuCommunity from '@space-shell/common/components/customMenu/menuCommunityItem/hooks/useMenuCommunity'
import { useMembershipStore } from '@space-shell/core/store'
import clsx from 'clsx'

export type GroupDeleteCommunityModalProps = {
  isOpen: boolean
  groupId: number
  closeModal: () => void
}

const paddingModalStyle = '_px-5 _py-5'

const GroupDeleteCommunityModal = ({
  isOpen,
  groupId,
  closeModal
}: GroupDeleteCommunityModalProps) => {
  const [isLoadingButton, setIsLoadingButton] = useState<boolean>(false)
  const { t } = useTranslation()
  const { deleteGroupMutation } = useMenuCommunity()
  const { membershipSlug: slug } = useMembershipStore()

  const handleDelete = async () => {
    setIsLoadingButton(true)

    await deleteGroupMutation({ groupId, slug })

    setIsLoadingButton(false)

    closeModal()
  }

  return (
    <Modal show={isOpen} onClose={closeModal}>
      <ModalHeader className='_px-5 _pt-5 _pb-0'>
        <div className='_pb-1 _d-flex _justify-content-between _align-items-center'>
          <h2 className='_m-0 _text-4 _text-gray-700'>{t('modal.delete_group.title')}</h2>
          <Button
            variation='tertiary'
            className='_p-0 _d-flex _border-0 _bg-transparent _text-gray-400 _cursor-pointer'
            onClick={closeModal}>
            <span className='_sr-only'>close</span>
            <Icon icon={faXmark} className='_w-5 _h-5' />
          </Button>
        </div>
      </ModalHeader>

      <ModalBody className={paddingModalStyle}>
        <p className='_text-gray-900'>{t('modal.delete_group.description')}</p>
      </ModalBody>

      <ModalFooter className={clsx('_align-itens-center _justify-content-end', paddingModalStyle)}>
        <Button
          type='button'
          variation='tertiary'
          aria-label={t('buttons.cancel')}
          onClick={closeModal}>
          {t('buttons.cancel')}
        </Button>

        <Button
          loading={isLoadingButton}
          type='submit'
          variation='danger'
          aria-label={t('modal.delete_group.delete_button')}
          onClick={handleDelete}>
          {t('modal.delete_group.delete_button')}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default memo(GroupDeleteCommunityModal)
